import { themes } from '../index.js';
import lightClassic from './light-classic.css.js';

themes["light-classic"] = lightClassic;
//# sourceMappingURL=index.js.map
